import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import axios from "axios";
import Monogram from "../components/Monogram";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = window.location.hash.split("session_id=")[1] || "";
    axios
      .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((res) => {
        navigate("/admin", { replace: true, state: { user: res.data } });
      })
      .catch(() => {
        navigate("/login", { replace: true });
      });
  }, [navigate]);

  return (
    <div
      data-testid="auth-callback"
      className="min-h-screen bg-ink text-ivory font-body flex flex-col items-center justify-center gap-5"
    >
      <Monogram className="w-14 h-14 text-gold animate-pulse" />
      <p className="flex items-center gap-2 text-sm text-ivory-dim">
        <Loader2 className="w-4 h-4 animate-spin text-gold" />
        Signing you in…
      </p>
    </div>
  );
}
